import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { BookPage } from '../booking/book-page';
import { useFunnelBoot } from '../booking/lib/boot';

/**
 * Step 1 of the funnel (MASTER_PLAN M5.3, M5.7).
 *
 * The route owns two things and nothing else: the funnel's server session, and
 * navigation. `BookPage` stays a pure component over the draft, so it can be rendered in
 * a test without a router and without a network — which is what the parity regression
 * test measures (ADR-008, FR-BOOK-01).
 */
export const Route = createFileRoute('/book')({
  component: BookRoute,
});

function BookRoute() {
  const navigate = useNavigate();
  useFunnelBoot('state');

  return (
    <BookPage
      onContinue={() => {
        /* No data in the URL — the draft travels on the server (FR-BOOK-09, ADR-018). */
        void navigate({ to: '/insurance' });
      }}
    />
  );
}
